import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';
import _ from 'lodash';

import { formatServerDateTime, formatDisplayDate, parseDisplayDate } from '@/util/MomentUtils';
import showSuccessMessage from '@/util/ShowSuccessMessage';
import showErrorMessage from '@/util/showErrorMessage';
import { validateForm } from '@/util/ParsleyUtils';

import SaveCustomerOrderGeneral from '../../../services/SaveCustomerOrderGeneral';

import tmplRelocationGeneralView from './RelocationGeneralView.hbs';
import moment from 'moment/moment';

const RelocationGeneralView = View.extend({
  template: tmplRelocationGeneralView,

  className: 'relocation-general-view',

  ui: {
    relocationDate: 'input[name="relocationDate"]',
    commandPOC: '#commandPOC',
    generalForm: '.general-form',
    firstName: '#firstName',
    lastName: '#lastName',
    email: '#email',
    telephone: '#telephone'
  },

  events: {
    'change @ui.commandPOC': 'onCommandPOCChange'
  },

  onRender() {
    const restrictStartDate = EXTERNAL && !this.model.get('isReadOnly');
    this.ui.relocationDate.datepicker({
      startDate: restrictStartDate ? moment().add(35, 'days').format('MM/DD/YYYY') : undefined,
      format: 'mm/dd/yyyy'
    });
    if (this.model.get('order').relocationDate) {
      this.ui.relocationDate.datepicker('setDate', formatDisplayDate(this.model.get('order').relocationDate));
    }
  },

  onCommandPOCChange() {
    const commandPOCs = this.model.get('orderDetails').commandPOCs;
    const commandId = this.ui.commandPOC.val();

    if (commandId) {
      const command = _.find(commandPOCs, { id: commandId });
      this.$('#firstName').val(`${command.firstName}`);
      this.$('#lastName').val(`${command.lastName}`);
      this.$('#email').val(command.email);
      this.$('#telephone').val(command.telephone);
    } else {
      this.$('#firstName').val('');
      this.$('#lastName').val('');
      this.$('#email').val('');
      this.$('#telephone').val('');
    }
    validateForm(this.ui.generalForm, 'commandPOCInfo');
  },

  async validate() {
    const isReadOnly = this.model.get('isReadOnly');

    try {
      if (isReadOnly) this.ui.generalForm.find(':input').prop('disabled', false);
      await validateForm(this.ui.generalForm);
      this.trigger('no:errors');
      return true;
    } catch {
      if (isReadOnly) {
        this.ui.generalForm.find(':input').prop('disabled', true);
      }
      this.trigger('has:errors');
      return false;
    }
  },

  async onAttach() {
    if (this.model.get('orderDetails').showValidation) {
      await this.validate();
    }
  },

  async onSave() {
    const serialFormData = Syphon.serialize(this);

    if (serialFormData.relocationDate) {
      const relocationDate = formatServerDateTime(parseDisplayDate(serialFormData.relocationDate));
      serialFormData.relocationDate = relocationDate;
    }

    const formData = {
      generalFormData: serialFormData,
      orderId: this.model.get('orderDetails').orderId,
      orderTypeId: this.model.get('orderDetails').orderTypeId
    };

    try {
      await SaveCustomerOrderGeneral(formData);
      this.showSaveSuccess();
    } catch (err) {
      this.showSaveError();
      throw new Error(err);
    }
  },

  showSaveError() {
    showErrorMessage({
      errorCode: 'saveError',
      errorTitle: 'Save Error',
      errorMessage:
        'An error occured while saving general information for this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showSaveSuccess() {
    showSuccessMessage({
      code: 'saveSuccess',
      title: 'Save Success',
      message: 'This order has been saved successfully.',
      hideAfter: 5
    });
  }
});

export default RelocationGeneralView;
